var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('style',{tag:"component"},[_vm._v("\n  a[data-user-id='"+_vm._s(_vm.user.id)+"'] { color: #3AB686 !important; }\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }